export default [
  {
    company: "Flashpoint",
    date: "October 2018 - Present",
    title: "Senior Software Engineer II",
    description: `Flashpoint is a cyber intelligence organization working across a wide range of areas from cyber security,
      threat analysis, terrorism, fraud mitigation, insider threats, and other illicit activity found on the deep and
      dark web. I've had the privilege of working in a uniquely challenging space alongside incredibly talented
      colleagues and modern technologies. As part of a small but impactful team of frontend engineers, I help maintain
      Flashpoint's core platform and contribute to the evolution of our cross-product <b>React</b> codebase.<br /><br />
      
      My work centers on building intuitive, reliable, and scalable user experiences. I manage and maintain our shared
      <b>React component library</b>, ensuring consistency with our <b>Design System</b> across multiple products. I've led efforts
      to design and implement complex interfaces such as our Investigation AI Workspace, which supports user chat,
      suggested prompts, and custom report generation. I also collaborate across the organization to strengthen platform
      usability i.e. improving performance, refining UI patterns, and making data more accessible for our users.<br /><br />

      Beyond feature development, I take an active role in shaping engineering practices and product direction. This includes
      partnering closely with Product and Design on requirements and technical documentation, driving end-to-end delivery
      from development through <b>Cypress testing</b> and production deployment, and establishing frontend standards informed by user-behavior
      metrics. I regularly present new functionality to engineering and product teams, assist teammates through code review and agile
      ceremonies, and serve on an AI Governance working group to help identify safe, effective AI tooling and workflow enhancements.<br /><br />

      While my primary focus is frontend engineering, I also contribute backend support when needed, building <b>RESTful APIs</b> with <b>Python</b>,
      <b>Flask</b>, and <b>Node.js</b>. For one such project, I developed an internal API wrapper for the Looker API in Python, enabling us to surface Looker
      maintained data directly within our platform using our own Design System and React component library. This allows us to deliver
      a consistent, unified user interface while preserving the full functionality and insight users expect from Looker dashboards.
      Across all of these efforts, my goal remains the same: to create thoughtful, reliable interfaces and tools that help users work
      more efficiently in a high-stakes environment.<br /><br />`,
    links: [{ href: "https://flashpoint.io", label: "Flashpoint" }],
  },
  {
    company: "Booksmart Touring / Daysheets",
    date: "June 2014 - July 2020",
    title: "Co-founder/Lead UI Engineer/Advisor",
    description: `I co-founded a company with two friends based around helping manage the hectic life on the road of
      touring musicians. Starting from the ground up, I helped determine the main technologies we would
      use, including <b>Django Rest Framework</b> for the RESTful API and <b>AngularJS</b> with the web
      platform. In the almost three years with Booksmart, I have worked on database and API architecture,
      database modeling, performance analysis, feature design, translating requirements specifications
      into technical specifications, and managing a team of part time developers. <br /><br /> Now we are looking to
      rebuild and rebrand Booksmart as Daysheets with a new look, better technologies, and a new team. I will be in
      an advisory role helping with decisions, code review, management, etc.`,
    links: [{ href: "https://booksmart.it", label: "Booksmart Touring" }],
  },
  {
    company: "Radial Inc.",
    date: "April 2018 - October 2018",
    title: "Senior UI Developer",
    description: `I was the sole UI developer within the tax and compliance team. While working with Radial as a
      contractor, I mainly used Javascript, HTML, and CSS to create and improve user interfaces for the
      monitoring and detection of fraudulent activity on ecommerce websites. Along with Javascript and jQuery,
      I utilized Ruby on Rails for new configuration pages to alert the fraud team of threats.`,
    links: [{ href: "https://www.radial.com/about/company", label: "Radial" }],
  },
  {
    company: "Oracle",
    date: "April to August, 2014, April to September 2015",
    title: "Applications Engineer",
    description: `While working for Oracle I worked with various technologies ranging from JavaScript, Git, JQuery,
      HTML, CSS, Handlebars, and an internal Javascript component library. I was tasked with developing
      new UI features to enhance user experience on their project management suite.`,
    links: [{ href: "https://www.oracle.com/applications/primavera/products/project-portfolio-management/index.html", label: "Oracle" }],
  },
  {
    company: "Institute for Advanced Study",
    date: "April 2013 to April 2014",
    title: "Junior Web Developer",
    description: `Utilizing the content management system <b>Drupal</b>, I helped build multiple web applications
      during this position. Specifically, I helped build a new video streaming website which included a
      quick page creation tool, automatic poster image creation using ffmpeg, and embedded videos using
      &lt;iframe&gt;. I also upgraded their time tracking web application to be more user friendly.`,
    links: [{ href: "https://ias.edu", label: "Institute for Advanced Study" }, { href: "https://video.ias.edu", label: "Institute for Advanced Study Video" }],
  },
];
